export const highlight = {
  attrs: {
    class: { default: 'highlight' }
  },
  parseDOM: [{ tag: `span.highlight` }],
  toDOM: function (mark) {
    return ['span', mark.attrs]
  }
}
